import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/image/3333.svg'


const _hoisted_1 = { class: "register-container" }
const _hoisted_2 = { class: "login-link" }

import { ref } from 'vue'
import axios from '@/api/auth'
import { useRouter } from 'vue-router'


export default /*@__PURE__*/_defineComponent({
  __name: 'RegisterView',
  setup(__props) {

const router = useRouter()
const username = ref('')
const password = ref('')
const email = ref('')

const handleRegister = async () => {
  try {
    const res = await axios.register({
      username:username.value,
      password:password.value,
      email:email.value
    })

    if (res.status === 200 || res.status === 201) {
      alert('회원가입이 완료되었습니다.')
      router.push('/login')
    } else {
      alert('회원가입 실패')
    }
  } catch (e) {
    console.error('회원가입 에러:', e)
    alert('회원가입 중 오류가 발생했습니다.')
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("img", {
      src: _imports_0,
      alt: "FiftyFifty 로고",
      class: "logo"
    }, null, -1)),
    _cache[6] || (_cache[6] = _createElementVNode("h2", null, "회원가입", -1)),
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((username).value = $event)),
      placeholder: "아이디",
      class: "input"
    }, null, 512), [
      [_vModelText, username.value]
    ]),
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
      type: "password",
      placeholder: "비밀번호",
      class: "input"
    }, null, 512), [
      [_vModelText, password.value]
    ]),
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((email).value = $event)),
      type: "email",
      placeholder: "이메일",
      class: "input"
    }, null, 512), [
      [_vModelText, email.value]
    ]),
    _createElementVNode("button", {
      class: "register-btn",
      onClick: handleRegister
    }, " 회원가입 "),
    _createElementVNode("p", _hoisted_2, [
      _cache[4] || (_cache[4] = _createTextVNode(" 이미 계정이 있으신가요? ")),
      _createVNode(_component_router_link, { to: "/login" }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [
          _createTextVNode(" 로그인 ")
        ])),
        _: 1,
        __: [3]
      })
    ])
  ]))
}
}

})